import React from 'react';
// import { collectorStats } from '@/lib/mock-data/collectors-data';
import { Users, ShoppingBag, DollarSign, Trophy, ChevronUp, BarChart,Wallet } from 'lucide-react';
import { hexToRgba } from '@/lib/utils/color-utils';

export function CollectorStats({ alldata }) {

  console.log('alldata');
  console.log(alldata.overviews  );

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
      {/* Total Collectors */}
      <div className="bg-white border border-zinc-200 rounded-md p-4 hover:border-zinc-300 transition-all duration-300">
        <div className="flex items-start justify-between">
          <div>
            <p className="text-[10px] uppercase tracking-wider text-zinc-500 mb-1">Total Collectors</p>
            <h3 className="text-2xl font-mono">{alldata.collectorCount}</h3>
          </div>
          <div className="w-8 h-8 rounded-full bg-zinc-100 flex items-center justify-center">
            <Users className="h-4 w-4 text-zinc-700" />
          </div>
        </div>
      </div>

      {/* Total Purchases */}
      <div className="bg-white border border-zinc-200 rounded-md p-4 hover:border-zinc-300 transition-all duration-300">
        <div className="flex items-start justify-between">
          <div>
            <p className="text-[10px] uppercase tracking-wider text-zinc-500 mb-1">Total Purchases</p>
            <h3 className="text-2xl font-mono">{alldata.totalPurchases}</h3>
          </div>
          <div className="w-8 h-8 rounded-full bg-zinc-100 flex items-center justify-center">
            <ShoppingBag className="h-4 w-4 text-zinc-700" />
          </div>
        </div>
      </div>

      {/* Total Revenue */}
      <div className="bg-white border border-zinc-200 rounded-md p-4 hover:border-zinc-300 transition-all duration-300">
        <div className="flex items-start justify-between">
          <div>
            <p className="text-[10px] uppercase tracking-wider text-zinc-500 mb-1">Total Secondary Volume</p>
            <h3 className="text-2xl font-mono">{(Math.round(alldata.overviews.totalSecondaryVolume.current * 100) / 100).toLocaleString('en-US')} ETH</h3>
          </div>
          <div className="w-8 h-8 rounded-full bg-zinc-100 flex items-center justify-center">
            <Wallet className="h-4 w-4 text-zinc-700" />
          </div>
        </div>
      </div>

      {/* Average Spent */}
      <div className="bg-white border border-zinc-200 rounded-md p-4 hover:border-zinc-300 transition-all duration-300">
        <div className="flex items-start justify-between">
          <div>
            <p className="text-[10px] uppercase tracking-wider text-zinc-500 mb-1">Avg. Spent per Collector</p>
            <h3 className="text-2xl font-mono">${alldata.avgSpentPerCollector.usd.toLocaleString('en-US')}</h3>
          </div>
          <div className="w-8 h-8 rounded-full bg-zinc-100 flex items-center justify-center">
            <BarChart className="h-4 w-4 text-zinc-700" />
          </div>
        </div>
      </div>
    </div>
  );
}

// Component for tier distribution
export function TierDistribution({ alldata }: { alldata: any }) {
  return (
    <div className="bg-white border border-zinc-200 rounded-md p-4 hover:border-zinc-300 transition-all duration-300">
      <div className="flex items-start justify-between mb-4">
        <p className="text-[10px] uppercase tracking-wider text-zinc-500 font-medium">Collector Tier Distribution</p>
        <div className="w-6 h-6 rounded-full bg-zinc-100 flex items-center justify-center">
          <Trophy className="h-3 w-3 text-zinc-700" />
        </div>
      </div>

      <div className="space-y-4">
        {Object.keys(alldata.tiersdistribution)
          .reverse()
          .map(key => {
            const tier = alldata.tiersdistribution[key];
            return (
              <div key={key} className="space-y-1">
                <div className="flex items-center justify-between">
                  <div className="flex items-center">
                    <div
                      className={`px-2 py-0.5 text-[8px] font-mono rounded border`}
                      style={{
                        color: tier.color,
                        borderColor: tier.color,
                        backgroundColor: hexToRgba(tier.color, 0.07)
                      }}
                    >
                      {tier.title}
                    </div>
                    <span className={`ml-2 text-[10px] font-mono`} style={{ color: tier.color }}>
                      {tier.count} collectors
                    </span>
                  </div>
                  <div className="text-right">
                    <p className="text-[10px] font-mono text-zinc-400" style={{ color: tier.color }}>
                      {tier.percent}%
                    </p>
                  </div>
                </div>

                <div className="relative h-2 w-full bg-zinc-100 rounded-full overflow-hidden">
                  <div
                    className={`absolute top-0 left-0 h-full rounded-full`}
                    style={{ width: `${tier.percent}%`, backgroundColor: tier.color }}
                  ></div>
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
}

// Component for badge distribution
export function BadgeDistribution({ alldata }: { alldata: any }) {
  return (
    <div className="bg-white border border-zinc-200 rounded-md p-4 hover:border-zinc-300 transition-all duration-300">
      <div className="flex items-start justify-between mb-4">
        <p className="text-[10px] uppercase tracking-wider text-zinc-500">Most Common Badges</p>
        <div className="w-6 h-6 rounded-full bg-zinc-100 flex items-center justify-center">
          <ChevronUp className="h-3 w-3 text-zinc-700" />
        </div>
      </div>

      <div className="space-y-3">
        {Object.keys(alldata.badgesdistribution).map(key => {
          const badge = alldata.badgesdistribution[key];
          if (badge.percent > 0) {
            return (
              <div key={badge.key} className="flex items-center">
                <div className="w-40 shrink-0">
                  <p className="text-[10px] font-mono">{badge.title}</p>
                </div>
                <div className="flex-1 h-4 bg-zinc-100 rounded-sm overflow-hidden mr-3">
                  <div className="h-full bg-zinc-800" style={{ width: `${badge.percent}%`, backgroundColor:badge.color }}></div>
                </div>
                <div className="w-20 text-right">
                  <p className="text-[10px] font-mono">
                    {badge.count} ({badge.percent}%)
                  </p>
                </div>
              </div>
            );
          }
        })}
      </div>
    </div>
  );
}
